export default __webpack_public_path__ + "static/media/assisted-reproduction.cae59320.png";